import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TransportService } from "../transport/transport.service";
import { StudentTransportSettingsService } from './student-transport-settings-service';
import { FormValidator } from "../form.validator";
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

declare let $: any;
declare let customToastr: any;

@Component({
  selector: 'app-student-transport-settings-popup',
  templateUrl: 'student-transport-settings.component.html',
  styleUrls: ['student-transport-settings.component.css'],
  providers: [TransportService, StudentTransportSettingsService, FormValidator]
})
export class StudentTransportSettingsComponent implements OnInit {

  @Input() studentName: string;
  @Input() visible: string;
  @Input() currType: string;
  @Input() studentId: string;
  @Input() academicId: string;
  @Input() academicYear: string;
  @Input() button_text: string;
  @Output() save_button_event: EventEmitter<any> = new EventEmitter();
  @Output() closePopup: EventEmitter<any> = new EventEmitter();

  busStopListData = [];
  selectStopFare = 0;
  selectedStopId = null;
  selectedBusId = null;
  busListData = [];
  viewStudentTerms = [];
  viewStudentTermIds = [];
  studentSelectedTerms = [];
  _studentSelectedTerms = [];
  selectAllTerms: boolean;
  oldButtonText;
  isLoading: boolean;

  constructor(private transportservice: TransportService, private studentTransportOptionsService: StudentTransportSettingsService, private formValidator: FormValidator, private translate: TranslateService) { }

  ngOnInit() {
    this.selectStopFare = 0;
    this.selectedStopId = null;
    this.selectedBusId = null;
    this.viewStudentTerms = [];
    this.viewStudentTermIds = [];
    this.studentSelectedTerms = [];
    this._studentSelectedTerms = [];
    this.oldButtonText = this.button_text;
    this.getStudentTermsDetails();
  }

  async popupOkAction() {
    let data = {
      studentId: this.studentId,
      academicId: this.academicId,
      busId: this.selectedBusId,
      stopId: this.selectedStopId,
      busTermStatuses: this.studentSelectedTerms
    };
    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        data[key] = (this.formValidator.validateIsDataForNumber(data[key]) && data[key] !== 'null') ? data[key] : null;
      }
    }

    this.isLoading = true;
    if (data.studentId && data.academicId && data.busId && data.stopId && data.busTermStatuses && data.busTermStatuses.length > 0) {
      this.button_text = "Please Wait...";
      this.studentTransportOptionsService.updateStudentDetails(data, localStorage.getItem('usertoken'))
        .subscribe(
          async (data: any) => {
            this.isLoading = false;
            this.button_text = this.oldButtonText;
            if (data.status) {
              const studentTransportOptionsAreUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('studentTransportOptionsAreUpdatedSuccessfully')); 
              customToastr(studentTransportOptionsAreUpdatedSuccessfullyTranslation, 'success');
              this.visible = 'none';
              this.save_button_event.emit();
            }
            else {
              customToastr(data.message, 'error');
            }
          },
          async error => {
            this.isLoading = false;
            this.button_text = this.oldButtonText;
            console.error(error);
            const thereWasAnErrorWhileUpdatingStudentTransportOptionsPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('thereWasAnErrorWhileUpdatingStudentTransportOptionsPleaseTryAgain')); 
            customToastr(thereWasAnErrorWhileUpdatingStudentTransportOptionsPleaseTryAgainTranslation, 'error');
          }
        );
    }
    else {
      this.isLoading = false;
      const pleaseProvideTheNecessaryDetailsTranslation = await firstValueFrom(this.translate.get('pleaseProvideTheNecessaryDetails')); 
      customToastr(pleaseProvideTheNecessaryDetailsTranslation, 'error');
    }
  }

  close() {
    this.visible = 'none';
    this.closePopup.emit();
  }

  editStudentAppendStopList() {
    this.isLoading = true;
    this.studentTransportOptionsService.fetchBusStop(localStorage.getItem('usertoken'), this.academicId)
      .subscribe(
        (data: any) => {
          this.isLoading = false;
          this.busStopListData = data;
          if (this.selectedStopId) {
            this.onChangeBusStopGetBusList(this.selectedStopId)
          }
        },
        error => {
          this.isLoading = false;
        }
      );
  }

  onChangeEditStudentStop(id) {
    this.onChangeBusStopGetBusList(id);
  }

  onChangeBusStopGetBusList(stopId) {
    this.isLoading = true;
    this.studentTransportOptionsService.getBusListForStop(stopId, localStorage.getItem('usertoken'), this.academicId)
      .subscribe(
        async (data: any) => {
          this.isLoading = false;
          this.busListData = data;
          if (this.busListData.length == 0) {
            const thereAreNoBusesPassingThroughTheStopTranslation = await firstValueFrom(this.translate.get('thereAreNoBusesPassingThroughTheStop')); 
            customToastr(thereAreNoBusesPassingThroughTheStopTranslation, 'error');
          }
          else {
            for (let i = 0; i < this.studentSelectedTerms.length; i++) {
              if (this.studentSelectedTerms[i].isEditable) {
                this.studentSelectedTerms[i].fkBusStopId = stopId;
              }
            }
          }
        },
        error => {
          this.isLoading = false;
          this.busListData = [];
        }
      );
  }

  getStudentTermsDetails() {
    this.isLoading = true;
    this.studentTransportOptionsService.getStudentTermsDetail(this.studentId, localStorage.getItem('usertoken'), this.academicId)
      .subscribe(
        (data: any) => {
          this.isLoading = false;
          if (data.success == true) {
            if (data.data.length > 0) {
              let busOptionExisting = data.data.filter(function (term) {
                return term.fkBusStopId ? true : false;
              });
              if (busOptionExisting && busOptionExisting.length > 0) {
                this.selectedStopId = busOptionExisting[0].fkBusStopId || null;
                this.selectedBusId = busOptionExisting[0].fkBusId || null;
              }
              else {
                this.selectedStopId = null;
                this.selectedBusId = null;
              }
            }
            var studentTerms = data.data;
            var sortedTerms = [];
            for (var i = (studentTerms.length - 1); i >= 0; i--) {
              sortedTerms.push(studentTerms[i]);
            }
            for (var i = 0; i < sortedTerms.length; i++) {
              if (sortedTerms[i].isSelectedTerm == undefined) {
                sortedTerms[i].isSelectedTerm = false;
              }
              else if (sortedTerms[i].isSelectedTerm) {
                this.viewStudentTerms.push(sortedTerms[i]);
                this.viewStudentTermIds.push(sortedTerms[i].pkBusStopTermId)
              }
              if (sortedTerms[i].isPaid == undefined) {
                sortedTerms[i].isPaid = false;
              }
              if (sortedTerms[i].isPaid) {
                sortedTerms[i].isEditable = false
              }
              else {
                sortedTerms[i].isEditable = true
              }
            }
            this.studentSelectedTerms = sortedTerms;
            this._studentSelectedTerms = sortedTerms;
            this.editStudentAppendStopList();
            this.changeAllSelectBoxVal();
          }
        },
        error => {
          this.isLoading = false;
        }
      );
  }

  onBusTermChanged(event, term) {
    let termId = term.pkBusStopTermId;
    let isChecked = event.currentTarget.checked;
    term.isSelectedTerm = isChecked;
    if (this.viewStudentTermIds.indexOf(termId) != -1 && isChecked == false) {
      let index = this.viewStudentTermIds.indexOf(termId);
      this.viewStudentTermIds.splice(index, 1);
    }
    else {
      this.viewStudentTermIds.push(termId)
    }
    this.changeAllSelectBoxVal();
  }
  onBusTermChangedSelectAll(event) {
    let isChecked = event.currentTarget.checked;
    for (let i = 0; i < this.studentSelectedTerms.length; i++) {
      if (isChecked == true) {
        this.studentSelectedTerms[i].isSelectedTerm = true;
        this.viewStudentTermIds.push(this.studentSelectedTerms[i].pkBusStopTermId);
      }
      else {
        if (!this.studentSelectedTerms[i].isEditable) {

        }
        else {
          this.studentSelectedTerms[i].isSelectedTerm = false;
          this.viewStudentTermIds.splice(i, 1);
        }
      }
    }
    this.changeAllSelectBoxVal();
  }

  changeAllSelectBoxVal() {
    this.selectAllTerms = this.viewStudentTermIds.length == this.studentSelectedTerms.length;
  }

  onEditBusTermChangedForFee() {

  }

}
